<template>
  <v-container fluid>
    <div class="contain-media elevation-1 grey lighten-4 mx-auto">
      <v-icon x-large v-show="imgSrc.length === 0">person</v-icon>
      <img v-show="imgSrc.length > 0" :src="imgSrc" @error="imageNotValid" alt="Profile Pic">
    </div>
    <div class="text-sm-center" v-if="getCurrentRoute !== 'Profile'">
      <v-menu v-model="dialog.open" top
        :close-on-content-click="false">
      <v-btn @click.native="addFile" color="primary" round outline slot="activator">Update Profile Pic</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Upload Profile Picture</span>
        </v-card-title>
        <v-card-text>
          <input @change="tmpUploadFile" type="file" accept="image/*" ref="imgUploadButton" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" round outline @click.native="dialog.open = false">Close</v-btn>
          <v-btn color="primary" round @click.native="saveFile">Save</v-btn>
        </v-card-actions>
      </v-card>
      </v-menu>
    </div>
  </v-container>
</template>
<script>
/* globals Store, Router */
import utils from '@/utils/utilities'
export default {
  name: 'ProfilePicCard',
  data () {
    return {
      dialog: {
        open: false
      },
      fileToSend: null,
      imgUploadSrc: '',
      imgUrl: '' // used in callback to give tmp url
    }
  },
  computed: {
    imgSrc () {
      return Store.state.user.profilePictureSrc
    },
    getCurrentRoute () {
      return Router.currentRoute.name
    }
  },
  methods: {
    imageNotValid () {
      Store.dispatch('user/viewProfilePicture')
    },
    cb (src) {
      this.imgUrl = src
    },
    tmpUploadFile (event) {
      const files = event.target.files
      if (files.length === 0) {
        this.fileToSend = null
        this.$refs.imgUploadButton.value = ''
        return
      }
      let filename = files[0].name
      if (!utils.getValidMediaType('ImgPrev', filename)) {
        this.imgUploadSrc = ''
        this.fileToSend = null
      } else {
        this.fileToSend = files[0]
        var URL = window.URL || window.webkitURL
        this.imgUploadSrc = URL.createObjectURL(this.fileToSend)
      }
    },
    addFile () {
      this.fileToSend = null
      this.imgUploadSrc = ''
      this.$refs.imgUploadButton.value = ''
      this.dialog.open = true
    },
    async saveFile () {
      Store.dispatch('user/uploadProfilePic', this.fileToSend)
      .then(res => {
        console.log('dispatch complete')
        this.dialog.open = false
      })
    }
  }
}
</script>
<style scoped>
.contain-media {
  height: 260px;
  width: 214px;
}
.contain-media > * {
  object-fit: contain;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfilePicCard.vue